import classNames from "classnames";
import React from "react";
import { INFO_CIRCLE_ICON, UPDATE_ICON, WARNING_TRIANGLE_ICON } from "../../utils/svgs_new";
import { withDefault } from "../../utils/withDefault";
import { CardButton } from "../CardButton/CardButton";
import { AppCard, AppCardContent } from "../Generic/AppCard";
import { AppIcon } from "../Generic/AppIcon";
import Flex from "../Generic/Flex";
import { If } from "../Generic/If";

interface Props {
  onAction?: () => void;
  actionTitle?: string;
  message?: string;
  readonly?: boolean;
  noShadow?: boolean;
  type?: "warning" | "info";
}

const WarningCard = (props: Props) => {
  const icon = props.type === "info" ? INFO_CIRCLE_ICON : WARNING_TRIANGLE_ICON;
  const iconFill = props.type === "info" ? "var(--primary-color)" : "var(--warning-color)";

  return (
    <AppCard
      className={classNames("WarningCard", {
        NoShadow: props.noShadow,
        TypeInfo: props.type === "info",
      })}
    >
      <AppCardContent>
        <Flex direction="column" alignItems="center" justifyContent="center" yGap={16}>
          <Flex xGap={10}>
            <div className="WarningCard_WarningIconContainer">
              <AppIcon icon={icon} fill={iconFill} size={20} />
            </div>
            <div className="WarningCard_MessageText">{props.message}</div>
          </Flex>
          <If condition={!withDefault(props.readonly, false)}>
            <CardButton color="warning" variation="filled" onClick={props.onAction}>
              <AppIcon icon={UPDATE_ICON} size={12} />
              <span>{props.actionTitle}</span>
            </CardButton>
          </If>
        </Flex>
      </AppCardContent>
    </AppCard>
  );
};

export default React.memo(WarningCard);
